module.exports = __webpack_public_path__ + "arrow-prev.jpg?6dd71ed61fcc91d14637fa32f8fe76f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-prev.jpg
// module id = 156
// module chunks = 0